module.exports = " <div> <div class=mask v-if=visible> </div> <div class=alert v-if=visible> <p class=header>{{title}}</p> <p class=message>{{num}}{{message}}</p> <div class=btn-group v-show=btn :class=\"{'col-1':!showCancelButton,'col-2':showCancelButton}\"> <button class=\"btn secondary\" v-show=cancelButtonText @click=\"handleActions('cancel')\">{{cancelButtonText}}</button><button class=\"btn secondary\" @click=\"handleActions('confirm')\">{{confirmButtonText}}</button> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert.vue
// module id = 133
// module chunks = 1